// extracted by css-extract-rspack-plugin
export default {"username":"Li4t75EfTbYA0ad6"};